import styled from 'styled-components';
import { Form, Select } from 'antd';

export const Bar = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    gap: 14px;
    background: ${({ theme }) => theme.colors.componentBackground};
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    padding: 12px 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
`;

export const IconBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 9px;
    background: ${({ theme }) => theme.colors.colorPrimaryBg};
    color: ${({ theme }) => theme.colors.accentColor};
    flex-shrink: 0;
`;

export const StoreColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 220px;
    flex: 1;
    max-width: 480px;
    width: 100%;
`;

export const StoreLabel = styled.span`
    font-size: 11px;
    color: ${({ theme }) => theme.colors.lightFont};
`;

export const StoreSelect = styled(Select)`
    width: 100%;

    .ant-select-selector {
        border-radius: 8px !important;
    }
`;

export const Summary = styled.div`
    margin-left: auto;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.lightFont};
    white-space: nowrap;

    /* Pinned to the top-right (bar padding), on the "Operando a loja" line. */
    @media (max-width: 767px) {
        position: absolute;
        top: 10px;
        right: 16px;
        line-height: 16px;
    }
`;

// Overrides the global `.ant-form-item` / `.ant-row` margins (!important).
export const StoreField = styled(Form.Item)`
    &.ant-form-item,
    .ant-form-item-row {
        margin: 0 !important;
    }

    .ant-form-item-margin-offset {
        display: none;
    }
`;
